// import { useState, useEffect } from "react";
// import { useGetFileMutation } from "../../api/vmsSlice";
// import { PopOver } from ".";

// const FilePreview = ({ fileKey, extension }) => {
// 	const [getFile] = useGetFileMutation();
// 	const [fileData, setFileData] = useState(null);
// 	const [popoverOpen, setPopoverOpen] = useState(false);
// 	const [anchorEl, setAnchorEl] = useState(null);
// 	const base64ToBlobUrl = (base64, type = "application/pdf") => {
// 		const binary = atob(base64);
// 		const array = Uint8Array.from(binary, char => char.charCodeAt(0));
// 		const blob = new Blob([array], { type });
// 		return URL.createObjectURL(blob);
// 	  };
// 	const fetcFileByKey = async (fileKey) => {
// 		try {
// 			const response = await getFile({ fileKey });
// 			if (response?.data?.data) {
// 				setFileData(response.data.data);
// 			}
// 		} catch (error) {
// 			console.error("Failed to fetch file:", error);
// 		}
// 	};
// 	const blobUrl = base64ToBlobUrl(fileData);
// 	console.log(blobUrl)
// 	useEffect(() => {
// 		if (!fileKey) return;
// 		fetcFileByKey(fileKey);
// 	}, [fileKey]);

// 	const handleClick = (e) => {
// 		setAnchorEl(e.currentTarget);
// 		setPopoverOpen(true);
// 	};

// 	const handleClose = () => {
// 		setPopoverOpen(false);
// 	};

// 	if (!fileKey || !fileData) return null;
// 	return (
// 		<>
// 			{extension === "pdf" ? (
// 				<>
// 					<div
// 						style={{ position: "relative", width: "100px", height: "100px", cursor: "pointer", overflow: "hidden", border: "1px solid var(--primary-color)", borderRadius: "2px" }}
// 						onClick={handleClick}
// 					>
// 						<object
// 							// data={`data:application/pdf;base64,${fileData}`}
// 							data={blobUrl}
// 							type="application/pdf"
// 							width="100%"
// 							height="100%"
// 							style={{
// 								width: "110px",
// 								height: "110px",
// 							}}
// 						/>
// 						<div //This div is to make the object tag clickable as clicking on object tag do not works in the case of embedded PDF viewer
// 							style={{
// 								position: "absolute",
// 								top: 0,
// 								left: 0,
// 								width: "100%",
// 								height: "100%",
// 								zIndex: 1,
// 								display:'flex',
// 								justifyContent:'center',
// 								alignItems:'center',
// 								textAlign:'center',
// 								backgroundColor:'#dcdcdc'
								
// 							}}
// 						>Click here to preview PDF</div>
// 					</div>
// 					<PopOver open={popoverOpen} anchorEl={anchorEl} onClose={handleClose} title={"PDF Preview"} width={"40vw"} height={"95vh"}>
// 						<object
// 							// data={`data:application/pdf;base64,${fileData}`}
// 							data={blobUrl} 
// 							type="application/pdf"
// 							width="auto"
// 							height="inherit"
// 							style={{
// 								width: "100%",
// 								height: "100%",
// 							}}
// 						></object>
// 					</PopOver>
// 				</>
// 			) : (
// 				<>
// 					<img
// 						src={`data:image/jpeg;base64,${fileData}`}
// 						style={{
// 							maxWidth: "100px",
// 							maxHeight: "100px",
// 							cursor: "pointer",
// 						}}
// 						onClick={handleClick}
// 					/>

// 					<PopOver open={popoverOpen} anchorEl={anchorEl} onClose={handleClose} title={"Image Preview"}>
// 						<img
// 							src={`data:image/jpeg;base64,${fileData}`}
// 							style={{
// 								maxWidth: "40vw",
// 								maxHeight: "40vh",
// 								display: "block",
// 							}}
// 						/>
// 					</PopOver>
// 				</>
// 			)}
// 		</>
// 	);
// };

// export default FilePreview;





import { useState, useEffect } from "react";
import { useGetFileMutation } from "../../api/vmsSlice";
import { PopOver } from ".";

const FilePreview = ({ fileKey, extension }) => {
	const [getFile] = useGetFileMutation();
	const [fileData, setFileData] = useState(null);
	const [popoverOpen, setPopoverOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);

	const base64ToBlobUrl = (base64, type = "application/pdf") => {
		const binary = atob(base64);
		const array = Uint8Array.from(binary, char => char.charCodeAt(0));
		const blob = new Blob([array], { type });
		return URL.createObjectURL(blob);
	};

	const fetchFileByKey = async (fileKey) => {
		try {
			const response = await getFile({ fileKey });
			if (response?.data?.data) {
				setFileData(response.data.data);
			}
		} catch (error) {
			console.error("Failed to fetch file:", error);
		}
	};

	useEffect(() => {
		if (!fileKey) return;
		fetchFileByKey(fileKey);
	}, [fileKey]);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
		setPopoverOpen(true);
	};

	const handleClose = () => {
		setPopoverOpen(false);
	};

	if (!fileKey || !fileData) return null;

	const blobUrl = base64ToBlobUrl(fileData);

	return (
		<>
			{extension === "pdf" ? (
				<>
					<div
						style={{
							position: "relative",
							width: "100px",
							height: "100px",
							cursor: "pointer",
							overflow: "hidden",
							border: "1px solid var(--primary-color)",
							borderRadius: "2px",
						}}
						onClick={handleClick}
					>
						<iframe
							src={`data:application/pdf;base64,${fileData}`}
							width="100%"
							height="100%"
							style={{
								pointerEvents: "none",
								border: "none",
								width: "110px",
								height: "110px",
							}}
							title="PDF Preview Thumbnail"
						></iframe>
						<div
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
								zIndex: 1,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								textAlign: "center",
								backgroundColor: "#dcdcdc",
							}}
						>
							Click here to preview PDF
						</div>
					</div>

					<PopOver
						open={popoverOpen}
						anchorEl={anchorEl}
						onClose={handleClose}
						title={"PDF Preview"}
						width={"40vw"}
						height={"95vh"}
					>
						<iframe
							src={`data:application/pdf;base64,${fileData}`}
							type="application/pdf"
							title="Full PDF Viewer"
							style={{
								width: "100%",
								height: "100%",
								border: "none",
							}}
						></iframe>
					</PopOver>
				</>
			) : (
				<>
					<img
						src={`data:image/jpeg;base64,${fileData}`}
						style={{
							maxWidth: "100px",
							maxHeight: "100px",
							cursor: "pointer",
						}}
						onClick={handleClick}
					/>

					<PopOver
						open={popoverOpen}
						anchorEl={anchorEl}
						onClose={handleClose}
						title={"Image Preview"}
					>
						<img
							src={`data:image/jpeg;base64,${fileData}`}
							style={{
								maxWidth: "40vw",
								maxHeight: "40vh",
								display: "block",
							}}
						/>
					</PopOver>
				</>
			)}
		</>
	);
};

export default FilePreview;
